export const CLIENT_EVENT_TYPES = {}

export const SERVER_EVENT_TYPES = {}

export const SERVER_COMMON_EVENTS = {
  INFO: 'info',
  ERROR: 'error',
  WARNING: 'warning',
  SUCCESS: 'success',
  LOADING: 'loading',
  ABORTED: 'aborted',
  REJECTED: 'rejected',
  FORBIDDEN: 'forbidden',
  AUTHENTICATING: 'authenticating',
}

export const MESSAGE_SERVER_EVENTS = {
  NEW_MESSAGE: 'new-message',
  MESSAGE_READ: 'message-read',
  MESSAGE_TYPING: 'message-typing',
  MESSAGE_DELIVERED: 'message-delivered',
}

export const PASSENGER_SERVER_EVENTS = {
  NEW_PASSENGER: 'passenger-added',
  PASSENGER_UPDATED: 'passenger-updated',
  PASSENGER_DELETED: 'passenger-deleted',
  PASSENGER_LIST_UPDATED: 'passenger-list-updated',
}

export const FLIGHT_SERVER_EVENTS = {
  NEW_FLIGHT: 'flight-added',
  FLIGHT_UPDATED: 'flight-updated',
  FLIGHT_DELETED: 'flight-deleted',
  FLIGHT_LIST_UPDATED: 'flight-list-updated',
}

export const AIRLINE_SERVER_EVENTS = {
  NEW_AIRLINE: 'airline-added',
  AIRLINE_UPDATED: 'airline-updated',
  AIRLINE_DELETED: 'airline-deleted',
  AIRLINE_LIST_UPDATED: 'airline-list-updated',
}

export const AIRPORT_SERVER_EVENTS = {
  NEW_AIRPORT: 'airport-added',
  AIRPORT_UPDATED: 'airport-updated',
  AIRPORT_DELETED: 'airport-deleted',
  AIRPORT_LIST_UPDATED: 'airport-list-updated',
}

export const PILOT_SERVER_EVENTS = {
  NEW_PILOT: 'pilot-added',
  PILOT_UPDATED: 'pilot-updated',
  PILOT_DELETED: 'pilot-deleted',
  PILOT_LIST_UPDATED: 'pilot-list-updated',
}

export const AIRCRAFT_SERVER_EVENTS = {
  NEW_AIRCRAFT: 'aircraft-added',
  AIRCRAFT_UPDATED: 'aircraft-updated',
  AIRCRAFT_DELETED: 'aircraft-deleted',
  AIRCRAFT_LIST_UPDATED: 'aircraft-list-updated',
}

export const BOOKING_SERVER_EVENTS = {
  NEW_BOOKING: 'booking-added',
  BOOKING_UPDATED: 'booking-updated',
  BOOKING_DELETED: 'booking-deleted',
  BOOKING_LIST_UPDATED: 'booking-list-updated',
}

export const BAGGAGE_SERVER_EVENTS = {
  NEW_BAGGAGE: 'baggage-added',
  BAGGAGE_UPDATED: 'baggage-updated',
  BAGGAGE_DELETED: 'baggage-deleted',
  BAGGAGE_LIST_UPDATED: 'baggage-list-updated',
}

export const NOTIFICATION_SERVER_EVENTS = {
  NEW_NOTIFICATION: 'new-notification',
}

export const NOTIFICATION_CLIENT_EVENTS = {}

export const SERVER_EVENT_BUS = 'NORTHLAKE_SERVER_EVENTS'
export const CLIENT_EVENT_BUS = 'NORTHLAKE_CLIENT_EVENTS'
